var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStatus = function SvgStatus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#status_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.662.983a3.502 3.502 0 0 0-1.604.345 3.623 3.623 0 0 0-1.29 1.044A3.66 3.66 0 0 0 5.473 1.33 3.538 3.538 0 0 0 3.866.983a3.164 3.164 0 0 0-.607.077C1.449 1.465.739 4.245.832 5.325c.392 4.623 5.134 7.248 6.002 7.721h.606c1.587-.965 5.423-3.667 5.731-7.672a3.987 3.987 0 0 0-.105-1.587 3.907 3.907 0 0 0-.714-1.408c-.33-.413-.74-.75-1.203-.991A3.637 3.637 0 0 0 9.662.983v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.465 7.787h3.043l.522-1.352a.307.307 0 0 1 .111-.14.292.292 0 0 1 .17-.053.31.31 0 0 1 .168.06c.05.035.088.085.111.143l.934 2.519 1.185-4.353a.31.31 0 0 1 .105-.181.292.292 0 0 1 .372-.004.3.3 0 0 1 .102.166l1.204 5.019.933-3.755a.329.329 0 0 1 .105-.16.282.282 0 0 1 .352-.02c.053.036.092.09.112.151l.681 1.93h2.856"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "status_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 .5h14v13H0z"
  })))));
};
export default SvgStatus;